// @generated by protoc-gen-connect-es v0.10.1 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.clickerAssessment.teacher.apis.proto (package geneo.lms.clickerAssessment.teacher.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateTeacherAssessmentSessionRequest, CreateTeacherAssessmentSessionResponse, GetTeacherPreviousAssessmentSessionRequest, GetTeacherPreviousAssessmentSessionResponse, UpdateTeacherAssessmentSessionRequest, UpdateTeacherAssessmentSessionResponse } from "./lms.clickerAssessment.teacher.apis_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service geneo.lms.clickerAssessment.teacher.apis.LmsClickerAssessmentTeacherAPIServiceV1
 */
export const LmsClickerAssessmentTeacherAPIServiceV1 = {
  typeName: "geneo.lms.clickerAssessment.teacher.apis.LmsClickerAssessmentTeacherAPIServiceV1",
  methods: {
    /**
     * @generated from rpc geneo.lms.clickerAssessment.teacher.apis.LmsClickerAssessmentTeacherAPIServiceV1.createTeacherAssessmentSession
     */
    createTeacherAssessmentSession: {
      name: "createTeacherAssessmentSession",
      I: CreateTeacherAssessmentSessionRequest,
      O: CreateTeacherAssessmentSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.clickerAssessment.teacher.apis.LmsClickerAssessmentTeacherAPIServiceV1.updateTeacherAssessmentSession
     */
    updateTeacherAssessmentSession: {
      name: "updateTeacherAssessmentSession",
      I: UpdateTeacherAssessmentSessionRequest,
      O: UpdateTeacherAssessmentSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.clickerAssessment.teacher.apis.LmsClickerAssessmentTeacherAPIServiceV1.getPreviousAssessmentSessionInfo
     */
    getPreviousAssessmentSessionInfo: {
      name: "getPreviousAssessmentSessionInfo",
      I: GetTeacherPreviousAssessmentSessionRequest,
      O: GetTeacherPreviousAssessmentSessionResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

